export type EnvironmentBannerConfig = {
  label: string;
  message: string;
  faviconPath: string;
  titleSuffix: string;
  bannerClassName: string;
};

const ENVIRONMENT_BANNERS: Partial<
  Record<string, EnvironmentBannerConfig>
> = {
  dev: {
    label: 'DEV',
    message:
      'DEV ENVIRONMENT – Test data only. Changes will not affect Production.',
    faviconPath: './favicon-dev.svg',
    titleSuffix: ' [DEV]',
    bannerClassName: 'dev-environment-banner',
  },
  qa: {
    label: 'UAT',
    message:
      'UAT ENVIRONMENT – Test data only. Changes will not affect Production.',
    faviconPath: './favicon-uat.svg',
    titleSuffix: ' [UAT]',
    bannerClassName: 'uat-environment-banner',
  },
};

/** True when the non-production environment banner should render (dev or UAT). */
export const showsEnvironmentBanner = (): boolean =>
  process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'qa';

/** @deprecated Use showsEnvironmentBanner — kept for existing imports. */
export const isUatEnvironment = (): boolean => process.env.NODE_ENV === 'qa';

export const getEnvironmentBannerConfig = ():
  | EnvironmentBannerConfig
  | undefined => {
  const env = process.env.NODE_ENV;
  if (!env) {
    return undefined;
  }

  return ENVIRONMENT_BANNERS[env];
};

/** @deprecated Use getEnvironmentBannerConfig — kept for existing imports. */
export const getUatEnvironmentBannerConfig = getEnvironmentBannerConfig;

export type UatEnvironmentBannerConfig = EnvironmentBannerConfig;
